// extracted by mini-css-extract-plugin
module.exports = {"SideMenu":"SideMenu_SideMenu__13Af-","MenuTitle":"SideMenu_MenuTitle__33g9w","Open":"SideMenu_Open__2xz1P","Close":"SideMenu_Close__fxt68"};